import { ReactElement } from 'react';
import { ModernizationUnitIcon } from 'icons';
import { BadgeContainer } from './styles';

interface BadgeProps {
  label: string;
}

export function Badge({
  label,
}: Readonly<BadgeProps>): ReactElement {
  return (
    <BadgeContainer>
      <ModernizationUnitIcon size={20} />
      <span>{label}</span>
    </BadgeContainer>
  );
}
